export const HOTEL_DETAILS_MODAL = "selectedHotelId";
export const HOTEL_DETAILS_ACTIVE_TAB = "hotel_details_active_tab";
export const MY_PASSENGERS = "my_passengers";
export const MODAL = "modal";
